var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketballCourt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_162)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_198_162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 180
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 0.196777H0.0117188V179.383H400V0.196777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_162)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 49.0623H211.855V56.5087H437.164V49.0623Z",
    fill: "#F0BD72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.855 49.0623H112.518V56.5087H211.855V49.0623Z",
    fill: "#E7B056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 -3.06714H171.804V4.37927H437.164V-3.06714Z",
    fill: "#F5C677"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 -3.06714H37.1699V4.37927H171.804V-3.06714Z",
    fill: "#E7B056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1642 -3.06714H-37.1699V4.37927H37.1642V-3.06714Z",
    fill: "#F5C677"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M371.753 26.7185H171.804V34.1649H371.753V26.7185Z",
    fill: "#F0BD72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1159 26.7185H-37.1699V34.1649H22.1159V26.7185Z",
    fill: "#F0BD72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 26.7185H371.753V34.1649H437.164V26.7185Z",
    fill: "#E7B056"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 26.7185H22.1157V34.1649H171.804V26.7185Z",
    fill: "#F5C677"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.518 49.0623H-37.1699V56.5087H112.518V49.0623Z",
    fill: "#F5C677"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 4.37939H198.556V11.8258H437.164V4.37939Z",
    fill: "#F5C677"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.19 11.8257H-37.1699V19.2721H228.19V11.8257Z",
    fill: "#F0BD72"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 11.8257H377.878V19.2721H437.164V11.8257Z",
    fill: "#F0BD72"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.562 4.37939H83.2397V11.8258H198.562V4.37939Z",
    fill: "#F0BD72"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.19 19.2722H-37.1699V26.7186H228.19V19.2722Z",
    fill: "#F5C677"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M362.83 19.2722H228.196V26.7186H362.83V19.2722Z",
    fill: "#E7B056"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 19.2722H362.83V26.7186H437.164V19.2722Z",
    fill: "#F5C677"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 4.37939H-37.1699V11.8258H83.2338V4.37939Z",
    fill: "#F5C677"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.884 11.8257H228.196V19.2721H377.884V11.8257Z",
    fill: "#F5C677"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 34.1694H198.556V41.6158H437.164V34.1694Z",
    fill: "#F5C677"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 41.6157H237.214V49.0621H437.164V41.6157Z",
    fill: "#E7B056"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.215 41.6157H177.929V49.0621H237.215V41.6157Z",
    fill: "#F0BD72"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M198.562 34.1694H83.2397V41.6158H198.562V34.1694Z",
    fill: "#E7B056"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2407 41.6157H-37.1699V49.0621H28.2407V41.6157Z",
    fill: "#E7B056"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 34.1694H-37.1699V41.6158H83.2338V34.1694Z",
    fill: "#F5C677"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177.935 41.6157H28.2466V49.0621H177.935V41.6157Z",
    fill: "#F5C677"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.438 56.5085H-37.1699V63.9549H201.438V56.5085Z",
    fill: "#F5C677"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M371.753 63.9551H171.804V71.4015H371.753V63.9551Z",
    fill: "#F0BD72"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1159 63.9551H-37.1699V71.4015H22.1159V63.9551Z",
    fill: "#F0BD72"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M316.76 56.5085H201.438V63.9549H316.76V56.5085Z",
    fill: "#F0BD72"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 71.4014H171.804V78.8478H437.164V71.4014Z",
    fill: "#F5C677"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 71.4014H37.1699V78.8478H171.804V71.4014Z",
    fill: "#E7B056"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 63.9551H371.753V71.4015H437.164V63.9551Z",
    fill: "#E7B056"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1642 71.4014H-37.1699V78.8478H37.1642V71.4014Z",
    fill: "#F5C677"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 56.5085H316.76V63.9549H437.164V56.5085Z",
    fill: "#F5C677"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 63.9551H22.1157V71.4015H171.804V63.9551Z",
    fill: "#F5C677"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M371.753 101.191H171.804V108.638H371.753V101.191Z",
    fill: "#F0BD72"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1159 101.191H-37.1699V108.638H22.1159V101.191Z",
    fill: "#F0BD72"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 101.191H371.753V108.638H437.164V101.191Z",
    fill: "#E7B056"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 101.191H22.1157V108.638H171.804V101.191Z",
    fill: "#F5C677"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 78.8477H198.556V86.2941H437.164V78.8477Z",
    fill: "#F5C677"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M228.196 86.2942H28.2466V93.7406H228.196V86.2942Z",
    fill: "#F0BD72"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 86.2942H377.878V93.7406H437.164V86.2942Z",
    fill: "#F0BD72"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.562 78.8477H83.2397V86.2941H198.562V78.8477Z",
    fill: "#F0BD72"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M228.19 93.7449H-37.1699V101.191H228.19V93.7449Z",
    fill: "#F5C677"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M362.83 93.7449H228.196V101.191H362.83V93.7449Z",
    fill: "#E7B056"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2407 86.2942H-37.1699V93.7406H28.2407V86.2942Z",
    fill: "#E7B056"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 93.7449H362.83V101.191H437.164V93.7449Z",
    fill: "#F5C677"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 78.8477H-37.1699V86.2941H83.2338V78.8477Z",
    fill: "#F5C677"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M377.884 86.2942H228.196V93.7406H377.884V86.2942Z",
    fill: "#F5C677"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 108.638H198.556V116.084H437.164V108.638Z",
    fill: "#F5C677"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M237.215 116.084H177.929V123.531H237.215V116.084Z",
    fill: "#F0BD72"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M198.562 108.638H83.2397V116.084H198.562V108.638Z",
    fill: "#E7B056"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2407 116.084H-37.1699V123.531H28.2407V116.084Z",
    fill: "#E7B056"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 108.638H-37.1699V116.084H83.2338V108.638Z",
    fill: "#F5C677"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M177.935 116.084H28.2466V123.531H177.935V116.084Z",
    fill: "#F5C677"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 116.084H237.214V123.531H437.164V116.084Z",
    fill: "#F5C677"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M201.438 123.531H-37.1699V130.977H201.438V123.531Z",
    fill: "#F5C677"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M371.753 130.977H171.804V138.423H371.753V130.977Z",
    fill: "#F0BD72"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5907 130.977H-37.1699V138.423H66.5907V130.977Z",
    fill: "#F0BD72"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M316.76 123.531H201.438V130.977H316.76V123.531Z",
    fill: "#F0BD72"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 138.423H171.804V145.87H437.164V138.423Z",
    fill: "#F5C677"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 138.423H37.1699V145.87H171.804V138.423Z",
    fill: "#E7B056"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 130.977H371.753V138.423H437.164V130.977Z",
    fill: "#E7B056"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1642 138.423H-37.1699V145.87H37.1642V138.423Z",
    fill: "#F5C677"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 123.531H316.76V130.977H437.164V123.531Z",
    fill: "#F5C677"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 130.977H66.5908V138.423H171.804V130.977Z",
    fill: "#F5C677"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M371.753 168.213H171.804V175.66H371.753V168.213Z",
    fill: "#F0BD72"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1159 168.213H-37.1699V175.66H22.1159V168.213Z",
    fill: "#F0BD72"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 168.213H371.753V175.66H437.164V168.213Z",
    fill: "#E7B056"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M171.804 168.213H22.1157V175.66H171.804V168.213Z",
    fill: "#F5C677"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 145.87H198.556V153.316H437.164V145.87Z",
    fill: "#F5C677"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M228.19 153.321H-37.1699V160.767H228.19V153.321Z",
    fill: "#F0BD72"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 153.321H377.878V160.767H437.164V153.321Z",
    fill: "#F0BD72"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M198.562 145.87H83.2397V153.316H198.562V145.87Z",
    fill: "#F0BD72"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M228.19 160.767H-37.1699V168.214H228.19V160.767Z",
    fill: "#F5C677"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M362.83 160.767H228.196V168.214H362.83V160.767Z",
    fill: "#E7B056"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 160.767H362.83V168.214H437.164V160.767Z",
    fill: "#F5C677"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 145.87H-37.1699V153.316H83.2338V145.87Z",
    fill: "#F5C677"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M377.884 153.321H228.196V160.767H377.884V153.321Z",
    fill: "#F5C677"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M437.164 175.66H198.556V183.106H437.164V175.66Z",
    fill: "#F5C677"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.562 175.66H83.2397V183.106H198.562V175.66Z",
    fill: "#E7B056"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2338 175.66H-37.1699V183.106H83.2338V175.66Z",
    fill: "#F5C677"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M-37.1699 -85.0212V264.986H437.164V-85.0212H-37.1699ZM400 179.965H8.29797e-05V113.8L88.6176 113.901V65.355L8.29797e-05 65.4556V-9.22388e-05H400V65.7357L311.472 65.6263V113.862L400 113.752V179.961V179.965Z",
    fill: "#A67C52"
  })))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8971 72.9634L64.4681 71.9133C63.223 72.8365 62.0668 73.8384 61.0352 74.8928L62.6716 75.7678C63.644 74.779 64.729 73.834 65.903 72.9677L65.8971 72.9634Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0209 85.8786L55.0227 85.6511C54.7559 86.9155 54.6255 88.2105 54.6255 89.4968V89.545L56.6473 89.4968C56.6473 88.2849 56.7719 87.0643 57.0209 85.8786Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0685 78.9003L58.266 78.2266C57.4655 79.3903 56.7896 80.6066 56.2441 81.8448L58.1652 82.2998C58.6751 81.136 59.3095 79.9941 60.0625 78.9003H60.0685Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5567 107.15C65.8078 108.069 67.1655 108.927 68.5885 109.688L69.7744 108.48C68.4344 107.763 67.1596 106.962 65.9797 106.096L64.5508 107.15H64.5567Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9131 68.632L72.9881 67.3064C71.4228 67.9014 69.9049 68.5927 68.4819 69.3583L69.6737 70.5615C71.0137 69.8396 72.4367 69.1877 73.9131 68.6277V68.632Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0464 93.4431C55.3251 94.7293 55.7401 96.0112 56.2915 97.245L58.2126 96.7813C57.6967 95.6219 57.3054 94.4187 57.0445 93.2112L55.0523 93.4431H55.0464Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3252 100.854C59.1316 102.009 60.0624 103.134 61.106 104.184L62.7365 103.304C61.7582 102.316 60.8807 101.266 60.1217 100.176L58.3252 100.854Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M200.969 0.0393066H0V180.004H400V0.0393066H200.969ZM2.02185 21.8491H31.306C76.9311 21.8491 114.629 47.3515 119.609 80.051C119.236 79.3947 118.821 78.7516 118.376 78.1259L118.459 78.0953C117.653 76.9403 116.716 75.8203 115.672 74.7702L115.577 74.8227C114.528 73.7771 113.366 72.7971 112.109 71.8871L108.071 69.3845C106.642 68.632 105.136 67.9582 103.559 67.372L98.6793 65.9063C97.0191 65.5169 95.3056 65.2238 93.5505 65.0269L88.321 64.7513H2.02185V21.8491ZM119.805 93.1631C119.55 94.3882 119.159 95.5825 118.649 96.7419H118.631C118.121 97.9013 117.481 99.0432 116.722 100.133L116.745 100.141C115.987 101.24 115.115 102.29 114.143 103.278L114.119 103.265C113.146 104.254 112.055 105.195 110.882 106.061L110.905 106.078C109.731 106.945 108.456 107.745 107.111 108.467L107.093 108.45C105.753 109.172 104.324 109.819 102.853 110.375L102.865 110.388C101.395 110.943 99.8533 111.416 98.2583 111.797V111.784C96.6752 112.164 95.0506 112.449 93.4082 112.641V112.65C92.1453 112.794 90.8528 112.877 89.5424 112.908V66.2519C106.494 66.6457 120.131 76.9272 120.173 89.523C120.173 90.1181 120.137 90.7175 120.078 91.3125C120.078 91.3256 120.078 91.3387 120.078 91.3475C120.012 91.9556 119.918 92.5594 119.793 93.1544H119.811L119.805 93.1631ZM2.02185 66.2432H78.0754L78.5082 67.2188C80.0854 66.8382 81.71 66.5451 83.3464 66.3526L83.3227 66.2432H87.5265V112.912C86.1687 112.886 84.805 112.812 83.4769 112.659L83.4176 112.939H78.1347L78.6327 111.805C77.0556 111.429 75.5081 110.957 74.0258 110.401L73.1067 111.731C74.3459 112.195 75.6385 112.589 76.9548 112.939H2.02185V66.2476V66.2432ZM2.02185 114.426H88.5404C102.486 114.426 114.475 108.135 119.574 99.2008C114.439 131.778 76.8125 157.149 31.306 157.149H2.02185V114.426ZM198.948 178.512H2.02185V158.641H31.306C81.4254 158.641 122.194 128.553 122.194 91.575V87.4274C122.194 50.4447 81.4194 20.3616 31.306 20.3616H2.02185V1.52684H198.948V47.5615C167.671 47.9641 142.395 66.847 142.395 90.0174C142.395 113.188 167.671 132.075 198.948 132.473V178.508V178.512ZM144.494 90.0218C144.494 67.6913 168.821 49.491 198.948 49.0578V130.986C168.821 130.553 144.494 112.352 144.494 90.0218ZM255.5 90.0218C255.5 112.352 231.173 130.553 201.046 130.986V49.0535C231.167 49.4866 255.5 67.687 255.5 90.0174V90.0218ZM397.978 157.149H368.694C323.188 157.149 285.567 131.778 280.426 99.2008C285.525 108.135 297.52 114.426 311.46 114.426H397.978V157.149ZM279.922 91.3562C279.922 91.3562 279.922 91.3343 279.922 91.3212C279.857 90.7262 279.827 90.1312 279.827 89.5318C279.869 76.9359 293.5 66.6544 310.458 66.2607V112.917C309.147 112.886 307.855 112.803 306.592 112.659V112.65C304.955 112.457 303.325 112.173 301.754 111.792V111.805C300.153 111.425 298.617 110.952 297.141 110.397L297.153 110.383C295.676 109.828 294.253 109.18 292.913 108.458L292.895 108.476C291.549 107.754 290.275 106.953 289.101 106.087L289.124 106.07C287.95 105.203 286.865 104.263 285.887 103.274L285.863 103.287C284.885 102.298 284.019 101.248 283.26 100.15L283.278 100.141C282.525 99.052 281.885 97.9101 281.369 96.7463H281.351C280.847 95.5957 280.456 94.4013 280.195 93.1763H280.213C280.088 92.5769 279.993 91.9731 279.928 91.3693L279.922 91.3562ZM397.978 112.934H323.045C324.356 112.584 325.648 112.19 326.893 111.727L325.974 110.397C324.498 110.952 322.944 111.425 321.367 111.801L321.865 112.934H316.582L316.523 112.654C315.189 112.807 313.831 112.882 312.474 112.908V66.2388H316.677L316.654 66.3482C318.29 66.5407 319.921 66.8338 321.492 67.2145L321.925 66.2388H397.978V112.93V112.934ZM397.978 64.7513H311.673L306.444 65.0269C304.689 65.2194 302.975 65.5169 301.315 65.9063L296.435 67.372C294.858 67.9582 293.346 68.6276 291.923 69.3845L287.885 71.8871C286.628 72.7971 285.472 73.7771 284.417 74.8227L281.618 78.1259C281.173 78.756 280.758 79.3947 280.385 80.051C285.365 47.3515 323.063 21.8491 368.688 21.8491H397.972V64.7513H397.978ZM397.978 20.3572H368.694C318.575 20.3572 277.806 50.4447 277.806 87.423V91.5706C277.806 128.553 318.581 158.636 368.694 158.636H397.978V178.508H201.052V132.473C232.329 132.071 257.605 113.188 257.605 90.0174C257.605 66.847 232.329 47.9597 201.052 47.5615V1.52684H397.978V20.3529V20.3572Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M338.965 74.8884C337.933 73.834 336.777 72.8365 335.532 71.9089L334.103 72.959C335.271 73.8296 336.362 74.7702 337.334 75.759L338.971 74.884L338.965 74.8884Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M343.353 89.4968L345.374 89.545V89.4968C345.374 88.2062 345.238 86.9111 344.977 85.6511L342.979 85.8786C343.228 87.0643 343.353 88.2849 343.353 89.4968Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M343.75 81.8448C343.211 80.6066 342.529 79.3903 341.728 78.2266L339.926 78.9003C340.679 79.9941 341.313 81.136 341.823 82.2998L343.744 81.8448H343.75Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M331.411 109.683C332.834 108.922 334.192 108.069 335.443 107.146L334.014 106.092C332.835 106.958 331.56 107.758 330.22 108.476L331.406 109.683H331.411Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M331.518 69.3625C330.095 68.5924 328.577 67.9012 327.012 67.3105L326.087 68.6362C327.563 69.1962 328.986 69.8437 330.326 70.57L331.518 69.3668V69.3625Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M341.787 96.7813L343.708 97.245C344.254 96.0112 344.675 94.7293 344.953 93.4431L342.961 93.2112C342.7 94.4187 342.309 95.6219 341.793 96.7813H341.787Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M338.894 104.179C339.931 103.129 340.868 102.009 341.674 100.85L339.878 100.172C339.119 101.261 338.241 102.311 337.263 103.3L338.894 104.179Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_198_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballCourt);
export default __webpack_public_path__ + "static/media/basketball-court.b301340e814187ddfd6f99635c59ad98.svg";
export { ForwardRef as ReactComponent };